import { render, staticRenderFns } from "./StateBrowserBuffer.vue?vue&type=template&id=3035a8a6&"
import script from "./StateBrowserBuffer.vue?vue&type=script&lang=js&"
export * from "./StateBrowserBuffer.vue?vue&type=script&lang=js&"
import style0 from "./StateBrowserBuffer.vue?vue&type=style&index=0&id=3035a8a6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports